<template>
  <v-chip
    :color="getOptions().color"
    outlined
    pill
    small
    dense
  >
    <v-icon small left v-text="getOptions().icon">
    </v-icon>
    {{user.EMP_SEX_TEXT}}
    <v-icon small right @click="showChooseGenderDialog = true" v-if="mode=='edit'">
      mdi-account-edit
    </v-icon>
    <chooseGenderDialog v-model="showChooseGenderDialog" :sexID="user.EMP_SEX" @onSexChanged="changeSex" />
  </v-chip>
</template>

<script>
import chooseGenderDialog from '@/components/modules/org/structure/staff/dialogs/chooseGenderDialog.vue'
export default {
  props: ['user', 'mode'],
  components: {
    chooseGenderDialog
  },
  data () {
    return {
      showChooseGenderDialog: false
    }
  },
  computed: {
  },
  methods: {
    changeSex (val) {
      this.$emit('onSexChanged', val)
    },
    getOptions () {
      var result = {
        color: 'black',
        icon: 'mdi-gender-non-binary'
      }
      switch (this.user.EMP_SEX) {
        case '1':
          result.color = 'indigo'
          result.icon = 'mdi-gender-male'
          break
        case '0':
          result.color = 'pink'
          result.icon = 'mdi-gender-female'
          break
      }
      return result
    }
  }
}
</script>
